import { Injectable, OnInit, Pipe } from '@angular/core';
import { Subject, BehaviorSubject, Observable, from } from 'rxjs';
import * as moment from 'moment-timezone';

import { ContainerApi } from '../sdk/services/custom/Container';
import { DocumentCategoryApi } from '../sdk/services/custom/DocumentCategory';
import { CountryCodeApi } from '../sdk/services/custom/CountryCode';
import { DatePipe, JsonPipe } from '@angular/common';
import { environment } from '../../environments/environment';
import { StateApi } from '../sdk/services/custom/State';
import { saveAs } from 'file-saver';
import { PmsIccPmcRecordTypeMappingApi, RecordTypeApi, AssignmentApi } from '../../shared/sdk/index';

import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { TeamShiftApi } from 'shared/sdk/services/custom/TeamShift';
import { ApiKeyApi } from './../sdk/services/custom/ApiKey';

@Injectable()
export class CommonService {
    public userProfile: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public jobRecordTypeSub: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private arrPrevNext: Subject<any> = new Subject<any>();
    // arrPrevNext$= this.arrPrevNext.asObservable();
    private accountTypeList = new BehaviorSubject<object>(null);
    private accountTypefilter = new BehaviorSubject<object>(null);
    private customAccountTypeList = new BehaviorSubject<object>(null);
    private customAccountTypefilter = new BehaviorSubject<object>(null);
    timeCardAdd: Subject<any> = new Subject<any>();
    private contactList = new BehaviorSubject<object>(null);
    private contactfilter = new BehaviorSubject<object>(null);
    public expenseTypeList: Subject<any> = new Subject<any>();
    jobRecordType: any = {};
    pmsRecordType: any = {};
    teamShiftData: Array<any> = [];
    teamShiftIccCaseNumber = {}
    private timeZone: string;
    pmcAllRecordType = [];

    constructor(
        private containerApi: ContainerApi,
        private documentCategoryApi: DocumentCategoryApi,
        private _countryCode: CountryCodeApi,
        private _state: StateApi,
        private _pmsIccPmcRecordTypeMappingApi: PmsIccPmcRecordTypeMappingApi,
        private _recordTypeApi: RecordTypeApi,
        private _teamShiftApi: TeamShiftApi,
        private _assignment: AssignmentApi,
        private _apiKey: ApiKeyApi
    ) {
        this.userProfile.subscribe(user => {
            if (user) {
                this.timeZone = user['timezone'];
            }
        });
    }

    setExpenseTypeList(expenseList: any) {
        this.expenseTypeList.next(expenseList);
    }

    setAccountTypeList(accountList: any) {
        this.accountTypeList.next(accountList);
    }
    getAccountTypeList() {
        return this.accountTypeList;
    }
    setAccountTypeFilter(filterCondition: any) {
        this.accountTypefilter.next(filterCondition);
    }
    getAccountTypeFilter() {
        return this.accountTypefilter;
    }

    setCustomAccountTypeList(accountList: any, controlName: string) {
        this.customAccountTypeList.next({
            ...this.customAccountTypeList.value,
            [controlName]: accountList
        });
    }
    getCustomAccountTypeList() {
        return this.customAccountTypeList;
    }
    setCustomAccountTypeFilter(filterCondition: any, controlName: string) {
        this.customAccountTypefilter.next({
            ...this.customAccountTypefilter.value,
            [controlName]: filterCondition
        });
    }
    getCustomAccountTypeFilter() {
        return this.customAccountTypefilter;
    }

    setContactList(contactList: any) {
        this.contactList.next(contactList);
    }
    getContactList() {
        return this.contactList;
    }
    setContactFilter(filterCondition: any) {
        this.contactfilter.next(filterCondition);
    }
    getContactFilter() {
        return this.accountTypefilter;
    }

    getUserProfile(): Observable<any> {
        return this.userProfile.asObservable();
    }

    setUserProfile(userProfile: any, isDelete = false) {
        if (!isDelete) {
            const imgpath = environment.baseUrl + '/' + environment.apiVersion;
            const imageUrl = (userProfile['url'] && userProfile['profileImage']) ?
                imgpath + '/Containers' + userProfile['url'] + '' + userProfile['profileImage'] : '';
            if (imageUrl) {
                this.imageExists(imageUrl, function (exists: any) {
                    userProfile['isProfile'] = (exists) ? imageUrl : '';
                });
            } else { userProfile['isProfile'] = ''; }
        } else {
            userProfile['isProfile'] = '';
        }
        this.userProfile.next(userProfile);
    }

    fetchApiKey() {
        this._apiKey.find({ where: { apiName: 'osmMapKey', isActive: true } }).subscribe(res => {
            if (res && res.length) {
                localStorage.setItem('osmMapObjKey', JSON.stringify(res[0]));
            }
        }, err => {
            console.log(err);
        });
    }

    fetchMapBoxTileLayerUrl() {
        const osmObj = JSON.parse(localStorage.getItem('osmMapObjKey'));
        // tslint:disable-next-line:max-line-length
        return `https://api.mapbox.com/styles/v1/${osmObj.webAccountName}/${osmObj.webStyleKey}/tiles/256/{z}/{x}/{y}?access_token=${osmObj.webApiKey}`
    }

    /*check if file exist in respective container*/
    fileExist(container, fileName) {
        return this.containerApi.getFile(container, fileName).map(res => res);
    }

    removeFile(container, fileName) {
        return this.containerApi.removeFile(container, fileName).map(res => res);
    }

    // check file type
    isImage(file: File): boolean {
        return /^image\//.test(file.type);
    }

    /**
     * get all category for listing page
     */
    getCategory(modelName) {
        return this.documentCategoryApi
            .find({
                where: {
                    isActive: 1,
                    modelName: modelName
                },
                fields: {
                    id: true,
                    title: true,
                    parentId: true
                }
            })
            .map(data => data);
    }

    setPrevNext(arrId) {
        const inArrID = [];
        arrId.forEach((item, index) => {
            inArrID.push(item['id']);
        });
        this.arrPrevNext.next(inArrID);
    }

    getPrevNext() {
        return this.arrPrevNext.asObservable();
    }

    getCountries() {
        return this._countryCode
            .find({ fields: { Name: true, Country__c: true }, order: 'Country__c' })
            .map(data => data);
    }
    /**
     *
     * @param fileName
     * @param allowedExtensions
     */
    validateExtention(fileName, allowedExtensions) {
        if (fileName) {
            const parts = fileName.split('.'),
                extension = parts[parts.length - 1];
            if (allowedExtensions.indexOf(extension.toLowerCase()) === -1) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    // Method to convert given time into different timezone with changeing time according to timezone. It will return ISO string.
    applyTimeZone(value: string, timeZone = '') {
        if (!timeZone) {
            timeZone = this.timeZone;
        }
        if (value) {
            const datePipe = new DatePipe('en-US');
            value = datePipe.transform(value, 'short', timeZone);
            return new Date(value).toISOString();
        } else {
            return value;
        }
    }

    // Method to convert date in timezone and given formate. It use moment timezone for convert timezone.
    convertTimeZone(value: string, timeZone: string, format = 'L LT') {
        if (value && timeZone) {
            const time = moment(value).tz(timeZone);
            return format ? time.format(format) : time.format();
        } else {
            return value;
        }
    }

    // Method to get same given time in different timezone
    setNewTimeZone(value: string, timeZone: string) {
        if (value && timeZone) {
            const time = moment(value);
            let newDate = time.format('MMM D, YYYY, h:mm:ss A');
            const tz = time.tz(timeZone).format('Z');
            newDate = newDate + ' ' + tz;
            const newTime = moment(new Date(newDate));
            return newTime.isValid() ? newTime.toISOString() : value;
        } else {
            return value;
        }
    }

    // Convert timezone of give ISO string and return new time in ISOString
    applyNewTimeZone(value: string, timeZone = '') {
        if (!timeZone) {
            timeZone = this.timeZone;
        }
        if (value && timeZone) {
            const time = moment(value);
            const tz = timeZone ? time.tz(timeZone).format('MMM D, YYYY, h:mm:ss A') : value;
            return new Date(tz).toISOString();
        } else {
            return value
        }
    }
    // format date based on momemnt. if timezone is available then also return timezone
    dateFormate(value: string, timeZone = '', format = 'MMM D, YYYY, h:mm:ss A') {
        const time = moment(value);
        if (value && time.isValid()) {
            return timeZone ? time.tz(timeZone).format(format) : time.format(format);
        } else {
            return value;
        }
    }

    /** Method to add Time 
     *  Type option : [y, m, d, h, m, s]
     **/

    addTime(value, addValue, type = 'h') {
        return moment(value).add(addValue, type);
    }

    /** Method to get difference between two dates
     *  Type option : [year, months, date, hour, minutes, seconds]
     **/

    getTimeDiff(dt1, dt2, type = 'minutes') {
        const date1 = dt1 ? moment(dt1) : moment();
        const date2 = dt2 ? moment(dt2) : moment();
        return date1.diff(date2, type);
    }

    concatinateStrings(dest, src, delimiter = ', ') {
        if (!src || src == '') return dest;
        if (!dest || dest == '') return src;
        return dest + delimiter + src;
    }

    getInterval(value, interval = 'week', format = '') {
        const date = moment(value);
        if (date.isValid()) {
            return format ? { start: date.startOf(interval).format(format), end: date.endOf(interval).format(format) } :
                { start: date.startOf(interval).toISOString(), end: date.endOf(interval).toISOString() }
        } else {
            return { start: '', end: '' }
        }

    }

    getDateDifference(start, end) {
        const startDate = moment(start);
        const endDate = moment(end);
        return endDate.diff(startDate, 'months');
    }

    getDateDifferenceDuration(date) {
        var now = moment(new Date());
        var end = moment(new Date(date));
        var duration = moment.duration(end.diff(now));
        return duration;
    }

    /**
     * 
     * @param url 
     * @param callback 
     */
    imageExists(url, callback) {
        var img = new Image();
        img.onload = function () { return callback(true); };
        img.onerror = function () { return callback(false); };
        img.src = url;
    }

    /**
     * 
     * @param name pass coountry's Name to get state list
     */
    getState(name: string) {
        return this._state
            .find({ where: { country_code: name }, order: 'name' })
            .map(data => data);
    }


    /**
       *
       * @param file
       * action list to perform download files
       */
    download(path, name) {
        saveAs(path, name);
    }

    /**
     * Method to download the multi files
     * @param files 
     */
    downloadMultiFiles(files: { path: string, name: string }[]) {
        for (let i = 0; i < files.length; i++) {
            this.download(files[i].path, files[i].name)
        }
    }

    /**
     * Method to download the multifiles as a zip
     * @param files 
     * @param zipFileName 
     */
    downloadFilesZip(files: { path: string, name: string }[], zipFileName = "serviceo-files.zip") {
        let map = new Map();
        // if files have same name file, then we will change the name
        files = files.map((item) => {
            if (map.has(item.name)) {
                // let ext = item['path'].split('.').pop()
                map.set(item.name, map.get(item.name) + 1);
                if (map.get(item.name) > 0) {
                    let baseName = item['name'].split('.')[0];
                    let extName = item['name'].split('.')[1];
                    item['name'] = baseName + ` (${map.get(item.name)})` + '.' + extName;
                }
            } else {
                map.set(item.name, 0);
            }
            return item;
        });

        var zip = new JSZip();
        var count = 0;

        files.forEach(function ({ path, name }) {
            let filename = name || path.split('/').pop() || 'untitled';

            // loading a file and add it in a zip file
            JSZipUtils.getBinaryContent(path, function (err, data) {
                if (err) {
                    throw err; // or handle the error
                }
                zip.file(filename, data, { binary: true });
                count++;
                if (count == files.length) {
                    zip.generateAsync({ type: 'blob' }).then(function (content) {
                        saveAs(content, zipFileName);
                    });
                }
            });
        });
    }

    /**
     * 
     * @param start 
     * @param end 
     * @param interval 
     * @param format 
     * use to change date at system's timezone to filter data.
     */
    getDateInterval(start, end, interval = '', format = '') {
        const startDate = moment(start);
        const endDate = moment(end);
        if (startDate.isValid() && endDate.isValid()) {
            return format ? { start: startDate.startOf(interval).format(format), end: endDate.endOf(interval).format(format) } :
                { start: startDate.startOf(interval).toISOString(), end: endDate.endOf(interval).toISOString() }
        } else if (startDate.isValid()) {
            return format ? { start: startDate.startOf(interval).format(format) } :
                { start: startDate.startOf(interval).toISOString() }
        } else {
            return { start: '', end: '' }
        }
    }
    /**
     * Method to fetch the teamshift data and store the response in @var teamShiftData 
     */
    fetchTeamShiftData(): Observable<any[]> {
        if (this.teamShiftData && this.teamShiftData.length > 0) {
            return Observable.of(this.teamShiftData);
        } else {
            return this._teamShiftApi.getTeamShiftData()
                .do(data => {
                    this.teamShiftData = data;
                    if (this.teamShiftData && this.teamShiftData.length > 0) {
                        let teamShiftSfdcIds = this.teamShiftData.map(item => item.sfdcId);
                        this.getTeamShiftIccCaseNumber(teamShiftSfdcIds);
                    }
                })
                .catch(this.handleError);
        }
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json() || 'Server error');
    }


    /**
     * Method to fetch the @var Task Model's @var ICC_Case_Number__c data corresponde to the teamShiftIds
     * and store the response in @var teamShiftIccCaseNumber 
     * @param teamShiftIds 
     */
    getTeamShiftIccCaseNumber(teamShiftIds: Array<string>) {
        const reqObj = {

            where: {
                and: [
                    {
                        Assigned_to_Team_Shift__c: {
                            inq: teamShiftIds
                        }
                    },
                    { or: [{ PgMO_Tasks__c: { neq: null } }, { PgMO_Tasks__c: { neq: '' } }] }
                ]
            },
            order: 'CreatedDate DESC',
            fields: ['sfdcId', 'PgMO_Tasks__c', 'Assigned_to_Team_Shift__c'],
            include: [
                {
                    relation: 'task',
                    scope: {
                        fields: ['sfdcId', 'ICC_Case_Number__c'],
                        where: { ICC_Case_Number__c: { neq: null } }
                    },
                },
            ],
            limit: 2000
        };
        let mapTeamShiftIds = teamShiftIds.reduce((map, key) => {
            map[key] = [];
            return map;
        }, {});

        this._assignment.find(reqObj).subscribe(
            (data) => {
                if (data && data.length > 0) {
                    data.forEach((item) => {
                        if ((item['Assigned_to_Team_Shift__c'] in mapTeamShiftIds) && item['task']) {
                            mapTeamShiftIds[item['Assigned_to_Team_Shift__c']].push(item['task']['ICC_Case_Number__c']);
                        }
                    })
                }
                this.teamShiftIccCaseNumber = mapTeamShiftIds;
            },
            err => {
                console.log('erro occured', err)
            }
        );
    }

    /**
     * Method to fetch the Job type Information
     * and store the response in @var pmcAllRecordType, @var pmsRecordType 
     * @param teamShiftIds 
     */
    fetchJobTypeInfo() {
        const reqObj = {
            'where': {
                or: [
                    { 'IsPMS__c': true },
                    { 'IsPMC__c': true },
                ]
            },
            'fields': ['sfdcId', 'RecordTypes__c', 'IsPMS__c', 'IsPMC__c', 'X3PL__c', 'IsFTE__c', 'IsHMS__c'],
            'include': [
                {
                    'relation': 'recordtype'
                }]
        };
        this._pmsIccPmcRecordTypeMappingApi.find(reqObj).subscribe((filterList: any) => {
            // added logic for the pmc data
            let pmcData = filterList.filter(data => data.IsPMC__c);
            let pmsData = filterList.filter(data => data.IsPMS__c);

            this.pmsRecordType['all'] = [];
            this.pmcAllRecordType = pmcData && pmcData.length > 0 ? pmcData.map(item => item.recordtype && item.recordtype.sfdcId) : [];
            const fte = [];
            const fru = [];
            const fse = [];
            for (let zz = 0; zz < pmsData.length; zz++) {
                const el = pmsData[zz];
                if (el && el.recordtype && el.recordtype.sfdcId) {
                    this.pmsRecordType['all'].push(el.recordtype.sfdcId);
                }
                if (el.IsFTE__c == true) {
                    fte.push(el.recordtype.sfdcId);
                } else if (el.X3PL__c == true) {
                    fru.push(el.recordtype.sfdcId);
                } else if (!el.X3PL__c && !el.IsFTE__c && !el.IsHMS__c) {
                    fse.push(el.recordtype.sfdcId);
                }

            }
            this.pmsRecordType['fte'] = fte;
            this.pmsRecordType['fru'] = fru;
            this.pmsRecordType['fse'] = fse;

        }, error => {
            console.log("Error occured:", error);
        });
        const reqObj2 = {
            'where': {
                'SobjectType': 'CKSW_BASE__Service__c'
            },
            'fields': ['sfdcId', 'Name']
        };
        this._recordTypeApi.find(reqObj2).subscribe((jobTypeList: any) => {
            jobTypeList.forEach(element => {
                switch (element.Name) {
                    case "FTE Dispatch":
                        this.jobRecordType['fte'] = element.sfdcId;
                        break;
                    case "FSE Dispatch":
                        this.jobRecordType['fse'] = element.sfdcId;
                        break;
                    case "FRU Dispatch":
                        this.jobRecordType['fru'] = element.sfdcId;
                        break;
                }
            });
            this.jobRecordTypeSub.next({ jobRecordType: this.jobRecordType });
        });
    }

    /**
    * Store timecard record type in local storage if not there and return it back
    */
    getTimecardRecordTypeIds() {
        if (localStorage.getItem('timecardRecordTypeIds') && JSON.parse(localStorage.getItem('timecardRecordTypeIds'))
            && JSON.parse(localStorage.getItem('timecardRecordTypeIds'))['dispatch']
            && JSON.parse(localStorage.getItem('timecardRecordTypeIds'))['contract']
            && JSON.parse(localStorage.getItem('timecardRecordTypeIds'))['dispatch'].length
            && JSON.parse(localStorage.getItem('timecardRecordTypeIds'))['contract'].length) {
            console.log('we already have timecard record type ids saved');
        } else {
            const data = {};
            this._recordTypeApi.find({
                fields: ['sfdcId', 'DeveloperName'],
                where: { 'SobjectType': 'Timecard__c' }
            }).subscribe(reply => {
                const dispatchIds = [];
                const contractIds = [];
                reply.forEach(item => {
                    if (item['DeveloperName'] && item['DeveloperName'] === 'Timecard') {
                        dispatchIds.push(item['sfdcId']);
                    }
                    if (item['DeveloperName'] && item['DeveloperName'] === 'Timesheet') {
                        contractIds.push(item['sfdcId']);
                    }
                })
                data['dispatch'] = dispatchIds;
                data['contract'] = contractIds;
                localStorage.setItem('timecardRecordTypeIds', JSON.stringify(data));
            }, error => {
                console.log(error);
            })
        }
    }

    /**
    * Store all filter in local storage
    * @param filterObj 
    */
    setGlobalFilter(filterObj) {
        let filterCondition = {};
        if (filterObj.contractCategory && filterObj.contractCategory.length) {
            filterCondition['ContractCategory'] = { inq: filterObj.contractCategory };
        }
        if (filterObj.orderTypes && filterObj.orderTypes.length) {
            filterCondition['OrderType'] = { inq: filterObj.orderTypes.map(item => item.sfdcId) };
        }
        if (filterObj.regions && filterObj.regions.length) {
            filterCondition['Region'] = { inq: filterObj.regions.map(item => item.sfdcId) };
        }
        if (filterObj.countries && filterObj.countries.length) {
            filterCondition['CountryCode'] = { inq: filterObj.countries.map(item => item.Name) };
        }
        if (filterObj.states && filterObj.states.length) {
            filterCondition['StateName'] = { inq: filterObj.states };
        }
        if (filterObj.vendorAccounts && filterObj.vendorAccounts.length) {
            filterCondition['Vendor__c'] = { inq: filterObj.vendorAccounts };
        }
        if (filterObj.accounts && filterObj.accounts.length) {
            filterCondition['CKSW_BASE__Account__c'] = { inq: filterObj.accounts };
        }
        if (filterObj.programs && filterObj.programs.length) {
            filterCondition['Project_SOP__c'] = { inq: filterObj.programs };
        }
        if (filterObj.jobSites && filterObj.jobSites.length) {
            filterCondition['Jobsite__c'] = { inq: filterObj.jobSites };
        }
        if (filterObj.jobs && filterObj.jobs.length) {
            filterCondition['Iron_Job_num__c'] = { inq: filterObj.jobs };
        }

        if (filterObj.statgeStatus && filterObj.statgeStatus.length) {
            filterCondition['Dispatch_Service_Resolution_Status__c'] = { inq: filterObj.statgeStatus };
        }
        if (filterObj.jobTypes && filterObj.jobTypes.length) {
            filterCondition['and'] = [{ "or": filterObj.recordTypeIds }];
        }
        if (filterObj.caseTypes && filterObj.caseTypes.length) {
            filterCondition['caseType'] = [{ "or": filterObj.pmsRecordTypeIds }];
        }
        if (filterObj.talentTypes && filterObj.talentTypes.length) {
            filterCondition['Talent_Type__c'] = { inq: filterObj.talentTypes };
        }

        if (filterObj.dateOptions && filterObj.dateOptions[0]) {
            const startDate = filterObj.dateOptions[0];
            filterCondition['CreatedDate'] = { between: [startDate[0], startDate[1]] };
        }
        if (filterObj.caseCategory && filterObj.caseCategory.length) {
            filterCondition['RecordTypeId'] = { inq: filterObj.caseCategory };
        }

        if (filterObj.priority && filterObj.priority.length) {
            filterCondition['Service_Dispatch_SLA_Priority__c'] = { inq: filterObj.priority };
        }
        if (filterObj.jobStatus && filterObj.jobStatus.length) {
            filterCondition['Job_Status_Internal__c'] = { inq: filterObj.jobStatus };
        }

        if (filterObj.workerNames && filterObj.workerNames.length) {
            filterCondition['Dispatch_Worker_Name__c'] = { inq: filterObj.workerNames };
        }

        if (filterObj.vendorSites && filterObj.vendorSites.length) {
            filterCondition['Vendorsite__c'] = { inq: filterObj.vendorSites };
        }

        if (filterObj.geoMetro && filterObj.geoMetro.length) {
            let jobsiteSfdcIds = [];
            jobsiteSfdcIds = jobsiteSfdcIds.concat(filterObj.jobSites, filterObj.geoMetroJobSite);
            jobsiteSfdcIds = Array.from(new Set(jobsiteSfdcIds));
            filterCondition['Jobsite__c'] = { inq: jobsiteSfdcIds };
        }
        // It's use for Team Shift
        if (filterObj.teamShifts && filterObj.teamShifts.length && filterObj.teamShiftUsers) {
            filterCondition['Case__c'] = { inq: filterObj.teamShiftUsers };
        }

        if (filterObj.pmsCaseStatus && filterObj.pmsCaseStatus.length) {
            filterCondition['PMS_Case_Status'] = { inq: filterObj.pmsCaseStatus };
        }
        /// direct search from case table pmsCaseNumbers
        if (filterObj.pmsCaseNumbers && filterObj.pmsCaseNumbers.length) {
            filterCondition['PMS_Case_Number'] = { inq: filterObj.pmsCaseNumbers };
        }
        /// direct search from case table pmcCaseNumbers
        if (filterObj.pmcCaseNumbers && filterObj.pmcCaseNumbers.length) {
            filterCondition['PMC_Case_Number'] = { inq: filterObj.pmcCaseNumbers };
        }
        // escalation type filter
        if (filterObj.escalationType && filterObj.escalationType.length) {
            filterCondition['Escalation_Type'] = filterObj.escalationType;
        }

        // project filter
        if (filterObj.projects && filterObj.projects.length) {
            filterCondition['PgMO_Projects__c'] = { inq: filterObj.projects };
        }

        // milestone filter
        if (filterObj.milestones && filterObj.milestones.length) {
            filterCondition['PgMO_Milestones__c'] = { inq: filterObj.milestones };
        }

        // task type filter
        if (filterObj.tasks && filterObj.tasks.length) {
            filterCondition['PgMo_Task__c'] = { inq: filterObj.tasks };
        }

        // taskStatus type filter
        if (filterObj.taskStatus && filterObj.taskStatus.length) {
            filterCondition['Task_Status__c'] = { inq: filterObj.taskStatus };
        }

        // taskRequestor type filter
        if (filterObj.taskRequestors && filterObj.taskRequestors.length) {
            filterCondition['Requestor__c'] = { inq: filterObj.taskRequestors };
        }

        // taskTypes type filter
        if (filterObj.taskTypes && filterObj.taskTypes.length) {
            filterCondition['Request_Type__c'] = { inq: filterObj.taskTypes };
        }

        // project type filter
        if (filterObj.projectTypes && filterObj.projectTypes.length && filterObj.projectTypes.filter(Boolean).length) {
            filterCondition['Project_Type__c'] = { inq: filterObj.projectTypes };
        }

        // project2 type filter
        if (filterObj.teamProjectTypes && filterObj.teamProjectTypes.length && filterObj.teamProjectTypes.filter(Boolean).length) {
            filterCondition['TeamProjectType'] = { inq: filterObj.teamProjectTypes };
        }
        // Either Account or Task Account filter will be active at a time. both can never be enable at the same time
        if (filterObj.taskAccounts && filterObj.taskAccounts.length) {
            filterCondition['Internal_Account_Id'] = { inq: filterObj.taskAccounts };
        }

        // Employee Type Filter
        //removing employee type filter when all is selected in employee type
        if (filterObj.employeeType && filterObj.employeeType.length && !filterObj.employeeType.includes('')) {
            filterCondition['Dispatch_worker_type'] = { inq: filterObj.employeeType };
        }

        // Implementing the timecard global filters
        if (filterObj.ironApprovalStatuses && filterObj.ironApprovalStatuses.length) {
            filterCondition['IRON_Approval_Status__c'] = { inq: filterObj.ironApprovalStatuses };
        }
        if (filterObj.customerApprovalStatuses && filterObj.customerApprovalStatuses.length) {
            filterCondition['Customer_Approval_Status__c'] = { inq: filterObj.customerApprovalStatuses };
        }
        // if (filterObj.actualCoverageHoures && filterObj.actualCoverageHoures.length) {
        //     filterCondition['Actual_Coverage_Hour__c'] = { inq: filterObj.actualCoverageHoures };
        // }
        // if (filterObj.actualEndTimeCoverages && filterObj.actualEndTimeCoverages.length) {
        //     filterCondition['Actual_End_Time_Coverage__c'] = { inq: filterObj.actualEndTimeCoverages };
        // }
        // if (filterObj.actualCoverageOveralls && filterObj.actualCoverageOveralls.length) {
        //     filterCondition['Actual_Coverage_Overall__c'] = { inq: filterObj.actualCoverageOveralls };
        // }
        //apply filter on worker_billing_Type_C worker under timecard
        if (filterObj.workerBillingTypes && filterObj.workerBillingTypes.ids && filterObj.workerBillingTypes.ids.length) {
            filterCondition['Worker_Billing_Type__c'] = { inq: filterObj.workerBillingTypes.ids };
        }

        if (filterObj.serviceContractNumbers && filterObj.serviceContractNumbers.length) {
            filterCondition['Service_Contract__c'] = { inq: filterObj.serviceContractNumbers };
        }

        if (filterObj.serviceContractCategory && filterObj.serviceContractCategory.length) {
            filterCondition['Service_Contract_Category__c'] = { inq: filterObj.serviceContractCategory };
        }

        // set filter condition for purchase Invoice Status
        if (filterObj.purchaseInvoiceStatus && filterObj.purchaseInvoiceStatus.length) {
            filterCondition['Purchase_Invoice_Status'] = { inq: filterObj.purchaseInvoiceStatus };
        }

        if (filterObj.divisions && filterObj.divisions.length) {
            filterCondition['Division__c'] = { inq: filterObj.divisions };
        }

        if (filterObj.departments && filterObj.departments.length) {
            filterCondition['Department__c'] = { inq: filterObj.departments };
        }

        if (filterObj.pgmo_departments && filterObj.pgmo_departments.length) {
            filterCondition['PgMO_Departments__c'] = { inq: filterObj.pgmo_departments };
        }

        if (filterObj.expenseTypes && filterObj.expenseTypes.length) {
            filterCondition['Expense_Type__c'] = { inq: filterObj.expenseTypes };
        }

        if (filterObj.expenseSubTypes && filterObj.expenseSubTypes.length) {
            filterCondition['Expense_sub_Type__c'] = { inq: filterObj.expenseSubTypes };
        }

        if (filterObj.paymentTypes && filterObj.paymentTypes.length) {
            filterCondition['Payment_Type__c'] = { inq: filterObj.paymentTypes };
        }

        //FOR ACCOUNT COMMUNITY
        if (filterObj.accountCommunities && filterObj.accountCommunities.length) {
            filterCondition['Account_Type__c'] = { inq: filterObj.accountCommunities };
        }
        if (filterObj.activityType && filterObj.activityType.length) {
            filterCondition['Activity_Type__c'] = { inq: filterObj.activityType };
        }
        if (filterObj.customerDateOptions && filterObj.customerDateOptions[0]) {
            const startDate = filterObj.customerDateOptions[0];
            filterCondition['Customer_Appointment_Start_Scheduled__c'] = { between: [startDate[0], startDate[1]] };
        }
        if (filterObj.taskPriorities && filterObj.taskPriorities.length) {
            filterCondition['Priority__c'] = { inq: filterObj.taskPriorities };
        }
        if (filterObj.taskStatuses && filterObj.taskStatuses.length) {
            filterCondition['Task_Status__c'] = { inq: filterObj.taskStatuses };
        }
        if (filterObj.users && filterObj.users.length) {
            filterCondition['Worker__c'] = { inq: filterObj.users };
        }
        if (filterObj.teams && filterObj.teams.length) {
            filterCondition['PgMO_Groups__c'] = { inq: filterObj.teams };
        }
        if (filterObj.dateFrom && filterObj.dateFrom.length) {
            filterCondition['Start_Date__c'] = { inq: filterObj.dateFrom };
        }
        if (filterObj.startFromDateOptions && filterObj.startFromDateOptions[0]) {
            const startDate = filterObj.startFromDateOptions[0];
            filterCondition['startFromDate'] = { between: [startDate[0], startDate[1]] };
        }
        if (filterObj.teamTypes && filterObj.teamTypes.length) {
            filterCondition['Team_Type'] = { inq: filterObj.teamTypes };
        }
        if (filterObj.departmentRoleAccesses && filterObj.departmentRoleAccesses.length) {
            filterCondition['Access__c'] = { inq: filterObj.departmentRoleAccesses };
        }
        if (filterObj.customers && filterObj.customers.length) {
            filterCondition['Customer__c'] = { inq: filterObj.customers };
        }

        // set local storage for mantain search filter on page changed
        localStorage.setItem('filterCondition', JSON.stringify(filterCondition));
    }
    /**
     * Read all filter from local storage
     * @param enableFilters
     */
    getGlobalFilter(enableFilters = []) {
        const globalFilterData = JSON.parse(localStorage.getItem('filterCondition'));
        const globalFilterObjData = JSON.parse(localStorage.getItem('filterObj'));
        if (globalFilterData && Object.keys(globalFilterData).length) {
            if (enableFilters && enableFilters.length) {
                const filterCondition = {};
                if (globalFilterData.Vendor__c && enableFilters.indexOf('vendorAccounts') > -1) {
                    filterCondition['Vendor__c'] = globalFilterData.Vendor__c;
                }
                // Either Account or Task Account filter will be active at a time. both can never be enable at the same time
                if (globalFilterData.CKSW_BASE__Account__c && enableFilters.indexOf('accounts') > -1) {
                    filterCondition['CKSW_BASE__Account__c'] = globalFilterData.CKSW_BASE__Account__c;
                }
                if (globalFilterData.Internal_Account_Id && enableFilters.indexOf('taskAccounts') > -1) {
                    filterCondition['Internal_Account_Id'] = globalFilterData.Internal_Account_Id;
                }
                if (globalFilterData.Project_SOP__c && enableFilters.indexOf('programs') > -1) {
                    filterCondition['Project_SOP__c'] = globalFilterData.Project_SOP__c;
                }
                // if josite filter is enabled
                if (globalFilterData.Jobsite__c && enableFilters.indexOf('jobSites') > -1) {
                    //if geo metro filter is also enabled and we have data in geo metro filter obj
                    if (enableFilters.indexOf('geoMetro') > -1 && globalFilterObjData['geoMetroJobSite']
                        && globalFilterObjData['geoMetroJobSite'].length) {
                        // if we have data in jobsite filter obj as well as in geo metro filter obj, going to extract common
                        if (globalFilterObjData['jobSites'] && globalFilterObjData['jobSites'].length > 0) {
                            filterCondition['Jobsite__c'] = {
                                inq: globalFilterObjData['geoMetroJobSite'].filter(geoItem =>
                                    globalFilterObjData['jobSites'].includes(geoItem)
                                )
                            }
                        } else {
                            // when we don't have data in jobsite filter obj
                            filterCondition['Jobsite__c'] = { inq: globalFilterObjData['geoMetroJobSite'] };
                        }
                    } else {
                        // only jobsite filter is enabled or we don't have data in geo metro filter obj
                        if (globalFilterObjData['jobSites'] && globalFilterObjData['jobSites'].length > 0) {
                            filterCondition['Jobsite__c'] = { inq: globalFilterObjData['jobSites'] };
                        }
                    }
                }
                if (globalFilterData.Iron_Job_num__c && enableFilters.indexOf('jobs') > -1) {
                    filterCondition['Iron_Job_num__c'] = globalFilterData.Iron_Job_num__c;
                }
                if (globalFilterData.Dispatch_Service_Resolution_Status__c && enableFilters.indexOf('statgeStatus') > -1) {
                    filterCondition['Dispatch_Service_Resolution_Status__c'] = globalFilterData.Dispatch_Service_Resolution_Status__c;
                }
                if (globalFilterData.and && enableFilters.indexOf('jobTypes') > -1) {
                    filterCondition['and'] = globalFilterData.and;
                }
                if (globalFilterData.caseType && enableFilters.indexOf('caseTypes') > -1) {
                    filterCondition['caseType'] = globalFilterData.caseType;
                }
                if (globalFilterData.Talent_Type__c && enableFilters.indexOf('talentTypes') > -1) {
                    filterCondition['Talent_Type__c'] = globalFilterData.Talent_Type__c;
                }
                if (globalFilterData.CreatedDate && enableFilters.indexOf('dateOptions') > -1) {
                    filterCondition['CreatedDate'] = globalFilterData.CreatedDate;
                }
                if (globalFilterData.RecordTypeId && enableFilters.indexOf('caseCategory') > -1) {
                    filterCondition['RecordTypeId'] = globalFilterData.RecordTypeId;
                }
                if (globalFilterData.Service_Dispatch_SLA_Priority__c && enableFilters.indexOf('priority') > -1) {
                    filterCondition['Service_Dispatch_SLA_Priority__c'] = globalFilterData.Service_Dispatch_SLA_Priority__c;
                }
                if (globalFilterData.Job_Status_Internal__c && enableFilters.indexOf('jobStatus') > -1) {
                    filterCondition['Job_Status_Internal__c'] = globalFilterData.Job_Status_Internal__c;
                }
                if (globalFilterData.Dispatch_Worker_Name__c && enableFilters.indexOf('workerNames') > -1) {
                    filterCondition['Dispatch_Worker_Name__c'] = globalFilterData.Dispatch_Worker_Name__c;
                }
                if (globalFilterData.Vendorsite__c && enableFilters.indexOf('vendorSites') > -1) {
                    filterCondition['Vendorsite__c'] = globalFilterData.Vendorsite__c;
                }
                if (globalFilterData.Jobsite__c && enableFilters.indexOf('geoMetro') > -1 &&
                    enableFilters.indexOf('jobSites') === -1) {
                    filterCondition['Jobsite__c'] = { inq: globalFilterObjData['geoMetroJobSite'] };
                }
                // WHEN JOBSITE AND GEO-METRO BOTH ARE AVAILABLE BUT ONLY ONE APPLIED
                if (globalFilterData.Jobsite__c && globalFilterData.Jobsite__c.inq &&
                    !globalFilterData.Jobsite__c.inq.length) {
                    filterCondition['Jobsite__c'] = { inq: [] }

                }
                if (globalFilterData.Case__c && enableFilters.indexOf('teamShiftUsers') > -1) {
                    filterCondition['Case__c'] = globalFilterData.Case__c;
                }
                if (globalFilterData.PMS_Case_Status && enableFilters.indexOf('pmsCaseStatus') > -1) {
                    filterCondition['PMS_Case_Status'] = globalFilterData.PMS_Case_Status;
                }
                if (globalFilterData.PMS_Case_Number && enableFilters.indexOf('pmsCaseNumbers') > -1) {
                    filterCondition['PMS_Case_Number'] = globalFilterData.PMS_Case_Number;
                }
                if (globalFilterData.PMC_Case_Number && enableFilters.indexOf('pmcCaseNumbers') > -1) {
                    filterCondition['PMC_Case_Number'] = globalFilterData.PMC_Case_Number;
                }
                if (globalFilterData.CountryCode && enableFilters.indexOf('countries') > -1) {
                    filterCondition['CountryCode'] = globalFilterData.CountryCode;
                }
                if (globalFilterData.StateName && enableFilters.indexOf('states') > -1) {
                    filterCondition['StateName'] = globalFilterData.StateName;
                }
                if (globalFilterData.Region && enableFilters.indexOf('regions') > -1) {
                    filterCondition['Region'] = globalFilterData.Region;
                }
                //key is in global filters
                if (globalFilterData.OrderType && enableFilters.indexOf('orderTypes') > -1) {
                    filterCondition['OrderType'] = globalFilterData.OrderType;
                }
                //key is in pms global filters
                if (globalFilterData.ContractCategory && enableFilters.indexOf('contractCategory') > -1) {
                    filterCondition['ContractCategory'] = globalFilterData.ContractCategory;
                }

                // escalation type filter
                if (globalFilterData.Escalation_Type && enableFilters.indexOf('escalationType') > -1) {
                    filterCondition['Escalation_Type'] = globalFilterData.Escalation_Type;
                }

                if (globalFilterData.PgMO_Projects__c && enableFilters.indexOf('projects') > -1) {
                    filterCondition['PgMO_Projects__c'] = globalFilterData.PgMO_Projects__c;
                }
                if (globalFilterData.PgMO_Milestones__c && enableFilters.indexOf('milestones') > -1) {
                    filterCondition['PgMO_Milestones__c'] = globalFilterData.PgMO_Milestones__c;
                }
                if (globalFilterData.PgMo_Task__c && enableFilters.indexOf('tasks') > -1) {
                    filterCondition['PgMo_Task__c'] = globalFilterData.PgMo_Task__c;
                }
                if (globalFilterData.Task_Status__c && enableFilters.indexOf('taskStatuses') > -1) {
                    filterCondition['Task_Status__c'] = globalFilterData.Task_Status__c;
                }
                if (globalFilterData.Requestor__c && enableFilters.indexOf('taskRequestors') > -1) {
                    filterCondition['Requestor__c'] = globalFilterData.Requestor__c;
                }
                if (globalFilterData.Request_Type__c && enableFilters.indexOf('taskTypes') > -1) {
                    filterCondition['Request_Type__c'] = globalFilterData.Request_Type__c;
                }
                if (globalFilterData.Project_Type__c && enableFilters.indexOf('projectTypes') > -1) {
                    filterCondition['Project_Type__c'] = globalFilterData.Project_Type__c;
                }
                if (globalFilterData.TeamProjectType && enableFilters.indexOf('teamProjectTypes') > -1) {
                    filterCondition['TeamProjectType'] = globalFilterData.TeamProjectType;
                }

                if (globalFilterData.Dispatch_worker_type && enableFilters.indexOf('employeeType') > -1) {
                    filterCondition['Dispatch_worker_type'] = globalFilterData.Dispatch_worker_type;
                }

                //Timecard filters
                if (globalFilterData.IRON_Approval_Status__c && enableFilters.indexOf('ironApprovalStatuses') > -1) {
                    filterCondition['IRON_Approval_Status__c'] = globalFilterData.IRON_Approval_Status__c;
                }
                if (globalFilterData.Customer_Approval_Status__c && enableFilters.indexOf('customerApprovalStatuses') > -1) {
                    filterCondition['Customer_Approval_Status__c'] = globalFilterData.Customer_Approval_Status__c;
                }
                if (globalFilterData.Actual_Coverage_Hour__c && enableFilters.indexOf('actualCoverageHours') > -1) {
                    filterCondition['Actual_Coverage_Hour__c'] = globalFilterData.Actual_Coverage_Hour__c;
                }
                if (globalFilterData.Actual_End_Time_Coverage__c && enableFilters.indexOf('actualEndTimeCoverages') > -1) {
                    filterCondition['Actual_End_Time_Coverage__c'] = globalFilterData.Actual_End_Time_Coverage__c;
                }
                if (globalFilterData.Actual_Coverage_Overall__c && enableFilters.indexOf('actualCoverageOveralls') > -1) {
                    filterCondition['Actual_Coverage_Overall__c'] = globalFilterData.Actual_Coverage_Overall__c;
                }
                if (globalFilterData.Worker_Billing_Type__c && enableFilters.indexOf('workerBillingTypes') > -1) {
                    filterCondition['Worker_Billing_Type__c'] = globalFilterData.Worker_Billing_Type__c;
                }
                if (globalFilterData.Service_Contract__c && enableFilters.indexOf('serviceContractNumbers') > -1) {
                    filterCondition['Service_Contract__c'] = globalFilterData.Service_Contract__c;
                }
                if (globalFilterData.Service_Contract_Category__c && enableFilters.indexOf('serviceContractCategory') > -1) {
                    filterCondition['Service_Contract_Category__c'] = globalFilterData.Service_Contract_Category__c;
                }
                // set filter condition for puchase Invoice Status
                if (globalFilterData.Purchase_Invoice_Status && enableFilters.indexOf('purchaseInvoiceStatus') > -1) {
                    filterCondition['Purchase_Invoice_Status'] = globalFilterData.Purchase_Invoice_Status;
                }
                if (globalFilterData.Division__c && enableFilters.indexOf('divisions') > -1) {
                    filterCondition['Division__c'] = globalFilterData.Division__c;
                }
                if (globalFilterData.Department__c && enableFilters.indexOf('departments') > -1) {
                    filterCondition['Department__c'] = globalFilterData.Department__c;
                }
                if (globalFilterData.PgMO_Departments__c && enableFilters.indexOf('pgmo_departments') > -1) {
                    filterCondition['PgMO_Departments__c'] = globalFilterData.PgMO_Departments__c;
                }
                if (globalFilterData.Expense_Type__c && enableFilters.indexOf('expenseTypes') > -1) {
                    filterCondition['Expense_Type__c'] = globalFilterData.Expense_Type__c;
                }
                if (globalFilterData.Expense_sub_Type__c && enableFilters.indexOf('expenseSubTypes') > -1) {
                    filterCondition['Expense_sub_Type__c'] = globalFilterData.Expense_sub_Type__c;
                }
                if (globalFilterData.Payment_Type__c && enableFilters.indexOf('paymentTypes') > -1) {
                    filterCondition['Payment_Type__c'] = globalFilterData.Payment_Type__c;
                }
                if (globalFilterData.Account_Type__c && enableFilters.indexOf('accountCommunities') > -1) {
                    filterCondition['Account_Type__c'] = globalFilterData.Account_Type__c;
                }
                if (globalFilterData.Activity_Type__c && enableFilters.indexOf('activityType') > -1) {
                    filterCondition['Activity_Type__c'] = globalFilterData.Activity_Type__c;
                }
                if (globalFilterData.Customer_Appointment_Start_Scheduled__c && enableFilters.indexOf('customerDateOptions') > -1) {
                    filterCondition['Customer_Appointment_Start_Scheduled__c'] = globalFilterData.Customer_Appointment_Start_Scheduled__c;
                }
                if (globalFilterData.Priority__c && enableFilters.indexOf('taskPriorities') > -1) {
                    filterCondition['Priority__c'] = globalFilterData.Priority__c;
                }
                if (globalFilterData.Worker__c && enableFilters.indexOf('users') > -1) {
                    filterCondition['Worker__c'] = globalFilterData.Worker__c;
                }
                if (globalFilterData.PgMO_Groups__c && enableFilters.indexOf('teams') > -1) {
                    filterCondition['PgMO_Groups__c'] = globalFilterData.PgMO_Groups__c;
                }
                if (globalFilterData.Start_Date__c && enableFilters.indexOf('dateFrom') > -1) {
                    filterCondition['Start_Date__c'] = globalFilterData.Start_Date__c;
                }
                if (globalFilterData.startFromDate && enableFilters.indexOf('startFromDateOptions') > -1) {
                    filterCondition['startFromDate'] = globalFilterData.startFromDate;
                }
                // this key was not in global filters
                if (globalFilterData.Team_Type && enableFilters.indexOf('teamTypes') > -1) {
                    filterCondition['Team_Type'] = globalFilterData.Team_Type;
                }
                if (globalFilterData.Access__c && enableFilters.indexOf('departmentRoleAccesses') > -1) {
                    filterCondition['Access_c'] = globalFilterData.Access__c;
                }
                if (globalFilterData.Customer__c && enableFilters.indexOf('customers') > -1) {
                    filterCondition['Customer__c'] = globalFilterData.Customer__c;
                }

                return filterCondition;
            } else {
                return globalFilterData;
            }
        } else {
            return {};
        }
    }
    setTimeCardAddSubject(count: any) {
        this.timeCardAdd.next(count);
    }

    replaceBreakWithComma(property: any): string {
        property = property.replace(/<br\/>/g, ', ');
        property = property.substring(0, property.length - 2);
        return property;
    }

    logger(...data){
        if(localStorage.getItem('loggerEnable') !== null && localStorage.getItem('loggerEnable') == 'enable'){
            console.log(data);
        }
    }
}
